export function roundToDecimalPlaces(number : number, decimals : number) {
    let factor = Math.pow(10, decimals);
    return Math.round(number * factor) / factor;
}

export function terseCount(number : number): string {
    if (number > 1000*1000)
        return `${roundToDecimalPlaces(number / 1000 / 1000, 2)}m`;
    if (number > 1000)
        return `${roundToDecimalPlaces(number / 1000, 1)}k`;
    
    return `${number}`;
}